import { render, staticRenderFns } from "./UsuarioGrupoFornecedorList.vue?vue&type=template&id=d77a076a&scoped=true"
import script from "./UsuarioGrupoFornecedorList.vue?vue&type=script&lang=js"
export * from "./UsuarioGrupoFornecedorList.vue?vue&type=script&lang=js"
import style0 from "./UsuarioGrupoFornecedorList.vue?vue&type=style&index=0&id=d77a076a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77a076a",
  null
  
)

export default component.exports